export default "__VITE_ASSET__DiwMziVU__"